/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {RenderElement} from "App/model/elements/element";

export default
class ExternalModel extends RenderElement {

    public static TypeName: string = "ExternalModel";

    constructor(aModelDescription: Description) {
        super(aModelDescription);
    }

    public static create(aModelDescription: Description, aUID: number): ExternalModel {
        let obj = new ExternalModel(aModelDescription);
        obj._typeName = ExternalModel.TypeName;
        obj._UID = aUID;
        return obj;
    }

    public parse(aElementDescriptionJSON: any): boolean {
        let ret = super.parse(aElementDescriptionJSON);
        if (!ret) {
            return false;
        }

        let document = this._modelDescription.getDocument();
        let baseUrl = this._modelDescription.getRenderModel().getBaseUrl();

        document.getSceneApiDocument().createModel(aElementDescriptionJSON.UID, baseUrl + "./" + aElementDescriptionJSON.UID + "/modelDescription.json", baseUrl + "./" + aElementDescriptionJSON.UID + "/geometryDescription.json", false, false);

        return true;
    }
}
